import {DOCUMENT} from '@angular/common';
import {Component, HostBinding, Inject, OnDestroy, OnInit} from '@angular/core';
import {Store} from '@ngrx/store';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {SubscriptionLike} from 'rxjs';
import {filter} from 'rxjs/operators';
import {CurrentModule} from './core/models/current-module';
import {selectCurrentContextFeature} from './core/redux/current-context/current-context-selectors';
import {CurrentContextState} from './core/redux/current-context/reducer/current-context.reducer';
import {ScreenWidthService} from './core/services/responsive/screen-width.service';
import {TitleService} from './core/services/title/title.service';
import { AlertModalComponent } from './entry-routes/alert-message/components/alert-modal/alert-modal.component';
import { ToasterComponent } from './core/ui/toaster/components/toaster.component';
import { RouterOutlet } from '@angular/router';
import { MaintenanceInfoComponent } from './core/ui/maintenance-info/maintenance-info.component';
import { MsalService } from '@azure/msal-angular';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [MaintenanceInfoComponent, RouterOutlet, ToasterComponent, AlertModalComponent]
})
export class AppComponent implements OnInit, OnDestroy {
  currentContext$ = this.store.select(selectCurrentContextFeature);

  @HostBinding('class.mobile') mobile = false;
  @HostBinding('class.desktop') desktop = false;

  title = 'Nexia';
  public screenWidth: number;
  private subs: SubscriptionLike[] = [];

  constructor(
    @Inject(DOCUMENT) public document,
    private titleService: TitleService,
    private screenWidthService: ScreenWidthService,
    public translate: TranslateService,
    private store: Store,
    private msalService: MsalService
  ) {
    // translate.setDefaultLang('fr');
    // translate.use('fr');
  }

  ngOnInit() {

    // remplace la balise app-redirect qui était dans template index.html
    this.subs.push(this.msalService.handleRedirectObservable().subscribe());

    // sets the Browser Page title
    this.subs.push(this.titleService.title.subscribe((title) => {
      this.document.title = title;
    }));

    this.subs.push(this.screenWidthService.screenWidth$.subscribe((screenWidth) => {
      let desktop = false;
      let mobile = false;
      this.screenWidth = screenWidth;
      if (this.screenWidth > 1023) {
        desktop = true;
      } else {
        mobile = true;
      }
      this.desktop = desktop;
      this.mobile = mobile;
    }));
    // this.subs.push(this.translate.get('GLOBAL.app_title').subscribe((response: string) => {
    //   this.title = response;
    //   this.titleService.setTitle(this.title);
    // }));

    this.subs.push(this.translate.onLangChange.pipe(
      filter((langChangeEvent: LangChangeEvent) => !!langChangeEvent.lang && !!langChangeEvent.translations)
    ).subscribe(() => {
      this.title = this.translate.instant('GLOBAL.app_title');
      this.titleService.setTitle(this.title);
    }));

    this.subs.push(this.currentContext$.pipe(
      filter((currentContext: CurrentContextState) => !!currentContext && !!currentContext.datas && !!currentContext.datas.currentModule && !currentContext.loading),
    ).subscribe((currentContextState: CurrentContextState) => {
      let color = '';
      let button_color = '';
      let rgb_accent_color = '';
      let pastel_color = '';
      let avatar_color_bg ='';
      let avatar_color_initials = '';
      switch (currentContextState.datas.currentModule) {
        case CurrentModule.GED:
          color = '#ff6255';
          button_color = '#ff6255';
          rgb_accent_color = '255, 98, 85';
          pastel_color = '#f6ae8e';
          avatar_color_bg = '#ff6255';
          avatar_color_initials = '#ffffff';
          break;
          case CurrentModule.WORKFLOW:
          color = '#35bab8';
          button_color = '#2f8c8e';
          rgb_accent_color = '53, 186, 184';
          pastel_color = '#a5d9d9';
          avatar_color_bg = '#ffffff';      // coté workflow : uniquement la version avec .switch : ex : resultat de recherche
          avatar_color_initials = '#505979';// coté workflow : uniquement la version avec .switch : ex :  resultat de recherche
          break;
      }
      document.documentElement.style.setProperty('--accent_color', color);
      document.documentElement.style.setProperty('--button_color', button_color);
      document.documentElement.style.setProperty('--rgb_accent_color', rgb_accent_color);
      document.documentElement.style.setProperty('--pastel_color', pastel_color);
      document.documentElement.style.setProperty('--avatar_color_bg', avatar_color_bg);
      document.documentElement.style.setProperty('--avatar_color_initials', avatar_color_initials);
    }));
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub: SubscriptionLike) => sub.unsubscribe());
  }

}
